module.exports = __webpack_public_path__ + "static/media/素梅干扣肉便當.3db9be82.jpg";